import { REDUCER_KEY } from './billerLoginsReducer';

export const getBillerLoginStore = (state) => state[REDUCER_KEY];

export const getBillerLoginsById = (state) => getBillerLoginStore(state).resourcesById;
export const getIsLoading = (state) => getBillerLoginStore(state).isLoading;
export const getLoadPending = (state) => getBillerLoginStore(state).loadPending;
export const getLastSyncDate = (state) => getBillerLoginStore(state).lastSyncDate;

export const getBillerLoginForId = (state, id) => getBillerLoginsById(state).get(id);

export const getDiscoveringLogin = (state) => getBillerLoginStore(state).discovering;
